import { render, staticRenderFns } from "./ModalFormResult.vue?vue&type=template&id=db44bd28&scoped=true"
import script from "./ModalFormResult.vue?vue&type=script&lang=js"
export * from "./ModalFormResult.vue?vue&type=script&lang=js"
import style0 from "./ModalFormResult.vue?vue&type=style&index=0&id=db44bd28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db44bd28",
  null
  
)

export default component.exports